<template>
  <div class="products__grid" :class="{adding: adding}">
    <div class="prev">
      <button type="button" @click="prev" v-show="showPrev">
        <Prev fill="var(--green)" :size="35"/>
      </button>
    </div>
    <div>
      <a class="compatible__product" :href="currentProduct.permalink" target="_blank">
        <div v-html="currentImage"></div>
      </a>
      <div class="compatible__name">{{ currentProduct.name }}</div>
      <div><strong>{{
          Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          }).format(Math.round(currentPrice))
        }}</strong>
      </div>
      <div class="compatible__variation-grid">
        <div>
          <select v-if="currentProduct.type === 'variable'" v-model.number="variationId">
            <option v-for="variation in currentProduct.variations" :value="variation.id">
              {{ variation.attributeSummary }}
            </option>
          </select>
        </div>
        <div class="compatible__add-to-cart">
          <button @click="addToCart" v-show="!added">
            <CartAdd v-show="!adding" :size="18"/>
            <Loader4 v-show="adding"/>
          </button>
          <div class="compatible__added">
            <CheckMarkAnimation v-show="added" :trigger="added" :size="38" title="Ajouté au panier"/>
          </div>
        </div>
      </div>
    </div>
    <div class="next">
      <button type="button" @click="next" v-show="showNext">
        <Next fill="var(--green)" :size="35"/>
      </button>
    </div>
  </div>
</template>

<script>
import ChevronRight from "@/components/icons/ChevronRight";
import Next from "@/components/icons/Next";
import Prev from "@/components/icons/Prev";
import CartAdd from "@/components/icons/CartAdd";
import Loader4 from "@/components/icons/Loader4";
import CheckMarkAnimation from "@/components/partials/CheckMarkAnimation";

export default {
  name: "CompatibleProduct",
  components: {CheckMarkAnimation, Loader4, CartAdd, Prev, Next, ChevronRight},
  props: {
    products: {
      type: Array,
      required: true,
      adding: false,
      added: false,
    },
  },
  data() {
    return {
      counter: 0,
      variationId: 0,
      adding: false,
      added: false,
    }
  },
  watch: {
    counter() {
      if (this.currentProduct.type === 'variable') {
        this.variationId = this.currentProduct.variations[0].id
      }
    },
  },
  computed: {
    currentProduct() {
      return this.products[this.counter]
    },
    currentVariation() {
      if (this.currentProduct.type === 'variable') {
        if (this.currentProduct.variations.length >= 1) {
          const index = this.currentProduct.variations.findIndex(variation => variation.id === this.variationId);
          if (index > -1) {
            return this.currentProduct.variations[index]
          }
        }
      }

      return {}
    },
    currentImage() {
      if (this.currentProduct.type === 'variable') {
        if (this.currentProduct.variations.length >= 1) {
          const index = this.currentProduct.variations.findIndex(variation => variation.id === this.variationId);
          if (index > -1) {
            return this.currentProduct.variations[index].img_html
          }
        }

      }

      return this.currentProduct.img_html;
    },
    currentPrice() {
      if (this.currentVariation.hasOwnProperty('price')) {
        return this.currentVariation.price
      }

      return this.currentProduct.price;
    },
    showNext() {
      return this.products.length > 1 && this.counter < (this.products.length - 1)
    },
    showPrev() {
      return this.counter > 0
    },
  },
  methods: {
    next() {
      this.counter = this.counter + 1
    },
    prev() {
      this.counter = this.counter - 1
    },
    addToCart() {
      this.adding = true
      const form = new FormData()
      form.append('product_id', ['simple','pack'].includes(this.currentProduct.type) ? this.currentProduct.id : this.variationId)
      form.append('quantity', '1')
      fetch('/?wc-ajax=add_to_cart', {
        method: 'POST',
        body: form,
      }).then(response => response.json())
        .then(data => {
          if (data.hasOwnProperty('cart_hash')) {
            this.added = true
            setTimeout(() => this.added = false, 3000)
          } else {
            alert(`Ce produit n'a pas pû être ajouté au panier.`)
          }
        })
        .finally(() => this.adding = false)
    },
  },
  mounted() {
    if (this.currentProduct.type === 'variable') {
      this.variationId = this.currentProduct.variations[0].id
    }
  },
}
</script>

<style scoped lang="scss">
.products__grid {
  display: grid;
  grid-template-columns: 30px auto 30px;
  min-height: 280px;
  transition: opacity .15s;

  &.adding {
    opacity: .15;
  }

  .prev, .next {
    display: flex;
    align-items: center;

    button {
      background-color: transparent;
      padding: 0;
      opacity: .5;

      &:hover {
        opacity: 1;
      }
    }
  }

  .compatible__product { // a
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .compatible__name {
    min-height: 48px;
  }

  .compatible__variation-grid {
    display: grid;
    grid-template-columns: 4fr 1fr;
    grid-gap: 0.5rem;
    margin-top: 1rem;

    select {
      height: 4rem;
      padding: .5rem 1rem;
    }
  }

  .compatible__add-to-cart {
    button {
      padding: 0;
      width: 45px;
      height: 4rem;
      //background-color: var(--green);
      background: linear-gradient(to bottom, #ff5b5b, orange);
    }
  }

  //.compatible__added {
  //  position: absolute;
  //  margin-left: 13rem;
  //  margin-top: 10rem;
  //}
}

</style>
